import React, { useState } from 'react';
import { Dialog, AppBar, Toolbar, IconButton, Icon, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useStyles from './RealmsCheckpointsModal.styles';
import { get } from 'global/lib/lodash';
import { Alert } from '@mui/material';
import { Text } from 'global/components/text';
import FlexibleLayout, { onNavigateLeft, onNavigateRight } from 'global/components/FlexibleLayout';
import SubScoreModal from 'global/components/SubScoreModal';
import RealmsCheckpointsList from './RealmsCheckpointsList';
import { getRealmChildTier } from 'global/utils';
import { useEffect } from 'react';

export const RealmsCheckpointsModal = (props) => {
  const { open, setIsOpen, realm, setRealm, realmDrop, assessment, filteredRealms, pssvTag, setPssvTag } = props;
  const classes = useStyles();
  const [error, setError] = useState();
  const [showRightPanel, setShowRightPanel] = useState();
  const [isDirty, setIsDirty] = useState(false);
  const tierChildLabel = getRealmChildTier(get(assessment, 'data.realm.tier', 'lot'));

  useEffect(() => {
    setShowRightPanel(!!pssvTag);
  }, [pssvTag]);

  const onCloseSubScoreModal = (created) => {
    if (created) {
      props.setAlerts?.({ message: 'INSTANCE ADDED!' });
    }
    setShowRightPanel(false);
  };

  const onCloseFlexibleLayout = () => {
    if (!props.preserveRealmOnClose) {
      setRealm({});
    }
    setPssvTag(null);
    setIsOpen(false);
  };

  return (
    <Dialog disableEscapeKeyDown open={open} onClose={onCloseFlexibleLayout} fullScreen>
      <Box className={classes.container}>
        <AppBar color="secondary">
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={onCloseFlexibleLayout} aria-label="Close" size="large">
              <Icon>close</Icon>
            </IconButton>
            <div style={{ marginLeft: 'auto' }}>
              {realmDrop({
                title: `${realm.name}`,
                placeholder: `CLICK TO CHANGE ${tierChildLabel}`,
              })}
            </div>
            {!!props.endIcon && (
              <Icon onClick={props.endIconClick} style={{ marginLeft: 'auto', cursor: props.endIconClick ? 'pointer' : 'default' }}>
                {props.endIcon}
              </Icon>
            )}
          </Toolbar>
        </AppBar>
        <Box className={classes.inputContainer}>
          {error && (
            <Alert
              severity="error"
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setError();
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
              {error}
            </Alert>
          )}
          <FlexibleLayout
            handleLeftPanelClose={onCloseFlexibleLayout}
            handleRightPanelClose={onCloseSubScoreModal}
            leftPanel={
              <RealmsCheckpointsList
                {...props}
                {...get(props, 'dialogProps', {})}
                filteredRealms={filteredRealms}
                subTitle="Click on inspection items below to create instances."
                setPssvTag={setPssvTag}
                setRealm={setRealm}
                tierChildLabel={tierChildLabel}
                onNavigateRight={onNavigateRight}
                isPreview={false}
              />
            }
            showRightPanel={showRightPanel}
            rightPanel={<SubScoreModal {...props} {...get(props, 'dialogProps', {})} pssvTag={pssvTag} onClose={onCloseSubScoreModal} isDirty={isDirty} setIsDirty={setIsDirty} />}
            defaultRightPanel={
              <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" height="80%">
                <Text type="label_large">
                  <strong>Click on an instance on the left panel to view it here.</strong>
                </Text>
              </Box>
            }
          />
        </Box>
      </Box>
    </Dialog>
  );
};

export default RealmsCheckpointsModal;
